import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Helper } from '../../../Helper';
import { IMessage } from '../../../interfaces/IMessage';
import { IAComposer } from '../../composer/Index';
import { MessagesStore } from '../stores';

export interface IProps {
  messagesStore?: MessagesStore;
  dataAutomationIdPrefix?: string;
  isContentCreator?: boolean;
  onClose?: () => void;
  onDelete?: () => void;
  reloadMessages?: () => void;
  saveTemplateCallback?: (jsonTemplate: string) => void;
}

export interface IState {
  toggleValue: boolean;
}

@inject('messagesStore')
@observer
export class EditPanel extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      toggleValue: false
    };
  }

  private checkForChanged(message: IMessage): boolean {
    let hasChanges = false;
    if (message && this.props.messagesStore.messageToEditOriginal) {
      if (
        JSON.stringify(message.title) !== JSON.stringify(this.props.messagesStore.messageToEditOriginal.title) ||
        JSON.stringify(message.content) !== JSON.stringify(this.props.messagesStore.messageToEditOriginal.content) ||
        JSON.stringify(message.image) !== JSON.stringify(this.props.messagesStore.messageToEditOriginal.image)
      ) {
        hasChanges = true;
      }
    }
    return hasChanges;
  }

  private getPath(url: string): string {
    if (url) {
      let urlArray = url.split("path=");
      if (urlArray && urlArray.length === 2) {
        return decodeURIComponent(urlArray[1]);
      }
    }
    return undefined;
  }

  render() {
    const composerConfiguration = this.props.messagesStore && this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.iaConfiguration ? this.props.messagesStore.messageToEdit.iaConfiguration : undefined;

    let top = 0;
    if (Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") {
      top = 48;
    }
    if (this.props.messagesStore.isMobileApp) {
      top = window.platform === "android" ? 50 : Helper.isIPhoneXType() ? 100 : 80;
    }
    // const eventCheck = false; // !(this.props.messagesStore.component === "Event" && (this.props.messagesStore.environment === "Production" || this.props.messagesStore.environment === "Test")); // this.props.messagesStore.component !== "Event";
    return (
      <IAComposer
        //open={this.props.messagesStore.instance && (this.props.messagesStore.messageToEdit != undefined && this.props.messagesStore.messageToEdit.iaConfiguration && this.props.messagesStore.messageToEdit.iaConfiguration.composerComponents != undefined || this.props.messagesStore.creatingNewMessage) && eventCheck && this.props.messagesStore.component !== "ContentOrganizer"}
        open={this.props.messagesStore.instance && this.props.messagesStore.messageToEdit != undefined && this.props.messagesStore.component !== "ContentOrganizer"}
        marginTop={top}
        isAdminPage={this.props.messagesStore.isAdminPage}
        environment={this.props.messagesStore.environment}
        token={this.props.messagesStore.token}
        tenant={this.props.messagesStore.tenant}
        instance={this.props.messagesStore.instance}
        fontSlots={this.props.messagesStore.fontSlots}
        component={this.props.messagesStore.component}
        user={this.props.messagesStore.user}
        userRole={this.props.messagesStore.userRole}
        author={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.author ? this.props.messagesStore.messageToEdit.author : undefined}
        highlightColor={this.props.messagesStore.highlightColor}
        placeholderColor="#999999"
        imageList="Lists/PublicRead_MessageAssets"
        videoList="Lists/PublicRead_MessageAssets"
        isMobile={this.props.messagesStore.isMobile}
        id={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.id ? this.props.messagesStore.messageToEdit.id : undefined}
        startDate={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.startDate ? this.props.messagesStore.messageToEdit.startDate : new Date()}
        endDate={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.endDate ? this.props.messagesStore.messageToEdit.endDate : undefined}
        allDayEvent={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.allDayEvent ? this.props.messagesStore.messageToEdit.allDayEvent : undefined}
        isBotInstalled={this.props.messagesStore.messageToEdit && this.props.messagesStore.isBotInstalled ? this.props.messagesStore.isBotInstalled : false}
        sendUsingBot={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.sendUsingBot ? this.props.messagesStore.messageToEdit.sendUsingBot : false}
        sendUsingBotOriginal={this.props.messagesStore.messageToEditOriginal?.sendUsingBot}
        creatingNewMessage={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.id == undefined}
        applicationSettings={this.props.messagesStore.applicationSettings}
        push={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.push ? this.props.messagesStore.messageToEdit.push : false}
        pushOriginal={this.props.messagesStore.messageToEditOriginal?.push}
        targetingExistingStructure={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.targetingExistingStructure ? this.props.messagesStore.messageToEdit.targetingExistingStructure : undefined}
        iaTargetingTargetContent={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.iaTargetingTargetContent ? this.props.messagesStore.messageToEdit.iaTargetingTargetContent : undefined}
        iaTargetingOperator={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.iaTargetingOperator ? this.props.messagesStore.messageToEdit.iaTargetingOperator : undefined}
        iaTargetingOperatorADGroups={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.iaTargetingOperatorADGroups ? this.props.messagesStore.messageToEdit.iaTargetingOperatorADGroups : undefined}
        targetingFields={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.targetingFields ? this.props.messagesStore.messageToEdit.targetingFields : undefined}
        iaTargetingGroupData={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.iaTargetingGroupData ? this.props.messagesStore.messageToEdit.iaTargetingGroupData : undefined}
        isDraft={this.props.messagesStore.messageToEdit ? this.props.messagesStore.messageToEdit.isDraft : false}
        approvalStatus={this.props.messagesStore.messageToEdit ? this.props.messagesStore.messageToEdit.approvalStatus : undefined}
        tenantSettings={this.props.messagesStore.tenantSettings}
        likesEnabledOnInstance={this.props.messagesStore.likesEnabled}
        commentsEnabledOnInstance={this.props.messagesStore.commentsEnabled}
        likesEnabled={this.props.messagesStore && this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.iaConfiguration ? !this.props.messagesStore.messageToEdit.iaConfiguration.disableLikes : true}
        commentsEnabled={this.props.messagesStore && this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.iaConfiguration ? !this.props.messagesStore.messageToEdit.iaConfiguration.disableComments : true}
        approvers={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.approvers ? this.props.messagesStore.messageToEdit.approvers : undefined}
        dataAutomationIdPrefix={this.props.dataAutomationIdPrefix}
        isFullPageView={this.props.messagesStore.isFullPageView}
        close={(editedMessage: IMessage) => {
          // Fix for mobile browser z-index issue
          if (this.props.messagesStore.isMobile && document.getElementById("IA_GlobalNavigator")) {
            const navigatorElement = document.getElementById("IA_GlobalNavigator");
            if (navigatorElement) {
              navigatorElement.style.display = "block";
            }
          }
          //
          if (this.checkForChanged(editedMessage)) {
            this.props.messagesStore.showCancelEditPopup = true;
            if (this.props.isContentCreator) {
              this.props.onClose();
            }
            return false;
          } else {
            if (this.props.isContentCreator) {
              this.props.onClose();
            } else {
              this.props.messagesStore.messageToEdit = undefined;
              this.props.messagesStore.creatingNewMessage = false;
            }
            if (this.props.messagesStore.showSortPinnedPanel) {
              this.props.messagesStore.refreshSortPinnedPanel = true;
            }
            return true;
          }
        }}
        closeAndReload={() => {
          if (this.props.messagesStore.showSortPinnedPanel) {
            this.props.messagesStore.refreshSortPinnedPanel = true;
          }
          this.props.messagesStore.messageToEdit = undefined;
          this.props.messagesStore.creatingNewMessage = false;
          this.props.reloadMessages();
        }}
        messageSaved={(message: IMessage) => {
          this.props.messagesStore.messageToEditOriginal = message;
          this.props.messagesStore.messageToEdit = message;
        }}
        delete={() => {
          if (this.props.messagesStore.showSortPinnedPanel) {
            this.props.messagesStore.refreshSortPinnedPanel = true;
          }
          this.props.messagesStore.messageToDelete = this.props.messagesStore.messageToEdit;
          this.forceUpdate();
          if (this.props.onDelete) {
            this.props.onDelete();
          }
        }}
        isReloadOk={(message: IMessage) => this.checkForChanged(message)}
        title={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.title ? {
          id: Helper.getRandomStringKey(),
          type: "title",
          text: this.props.messagesStore.messageToEdit.title
        } : {
          id: Helper.getRandomStringKey(),
          type: "title"
        }}
        teaser={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.teaser ? {
          id: Helper.getRandomStringKey(),
          type: "teaser",
          text: this.props.messagesStore.messageToEdit.teaser
        } : {
          id: Helper.getRandomStringKey(),
          type: "teaser"
        }}
        location={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.location ? {
          id: Helper.getRandomStringKey(),
          type: "location",
          text: this.props.messagesStore.messageToEdit.location
        } : {
          id: Helper.getRandomStringKey(),
          type: "location"
        }}
        contentComponents={composerConfiguration && composerConfiguration.composerComponents ? composerConfiguration.composerComponents : (this.props.messagesStore.creatingNewMessage ? [{ type: "text", id: Helper.getRandomStringKey() }] : [])}
        cover={{
          id: Helper.getRandomStringKey(),
          type: "cover",
          typeToEdit: "image",
          image: {
            source: "Link",
            url: this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.image ? (this.props.messagesStore.messageToEdit.image.indexOf("intraactive-image-functions") != -1 ? this.getPath(this.props.messagesStore.messageToEdit.image) : this.props.messagesStore.messageToEdit.image) : undefined,
            cropSettings: composerConfiguration?.cropSettings ? composerConfiguration?.cropSettings : undefined,
            modified: this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.modified && typeof (this.props.messagesStore.messageToEdit.modified) !== 'string' ? this.props.messagesStore.messageToEdit.modified.toISOString().replace(/[^\d]/g, '') : undefined,
            altText: composerConfiguration && composerConfiguration.headerImageAltText ? composerConfiguration.headerImageAltText : undefined,
            onlyShowCoverImageInRollup: composerConfiguration && composerConfiguration.onlyShowCoverImageInRollup ? composerConfiguration.onlyShowCoverImageInRollup : false
          },
          video: {
            source: this.props.messagesStore.messageToEdit?.videoEmbedCode ? (this.props.messagesStore.messageToEdit?.videoUrl ? "Microsoft" : "Embed") : "Link",
            embedCode: this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.videoEmbedCode ? this.props.messagesStore.messageToEdit.videoEmbedCode : undefined,
            url: this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.videoUrl ? this.props.messagesStore.messageToEdit.videoUrl : undefined,
            altText: composerConfiguration && composerConfiguration.headerVideoAltText ? composerConfiguration.headerVideoAltText : undefined,
          }
        }}
        subjects={{
          id: Helper.getRandomStringKey(),
          type: "subjects",
          categories: this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.categories ? this.props.messagesStore.messageToEdit.categories : []
        }}
        contacts={{
          id: Helper.getRandomStringKey(),
          type: "contacts",
          users: this.props.messagesStore.messageToEdit?.contacts ?? []
        }}
        attachments={{
          id: Helper.getRandomStringKey(),
          type: "attachments",
          files: composerConfiguration && composerConfiguration.attachments ? composerConfiguration.attachments : []
        }}
        getUserRole={() => this.props.messagesStore.getUserRole()}
        htmlContent={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.content ? this.props.messagesStore.messageToEdit.content : undefined}
        configuration={this.props.messagesStore.messageToEdit && this.props.messagesStore.messageToEdit.iaConfiguration ? this.props.messagesStore.messageToEdit.iaConfiguration : undefined}
        selectedFeeds={this.props.messagesStore.messageToEdit?.feeds?.split(',') ?? []}
        isPinned={this.props.messagesStore.messageToEdit?.isPinned}
        pinnedEndDate={this.props.messagesStore.messageToEdit?.pinnedEndDate}
        publishToReplayByDefault={this.props.messagesStore.creatingNewMessage && this.props.messagesStore.instance?.settings?.publishToFeedByDefault}
        isNewsLink={this.props.messagesStore.messageToEdit?.iaConfiguration?.isNewsLink}
        newsLink={this.props.messagesStore.messageToEdit?.iaConfiguration?.newsLink}
        openNewsLinkInNewTab={this.props.messagesStore.messageToEdit?.iaConfiguration?.openNewsLinkInNewTab}
        isMessagesTemplateEditor={this.props.messagesStore.isMessagesTemplateEditor}
        saveTemplateCallback={(jsonTemplate) => this.props.saveTemplateCallback(jsonTemplate)}
        isCreatingFromTemplate={this.props.messagesStore.isCreatingFromTemplate}
        recurrenceInfo={{
          isRecurring: this.props.messagesStore.messageToEdit?.recurrence,
          recurrenceData: this.props.messagesStore.messageToEdit?.recurrenceData,
          isEditingOccurrence: this.props.messagesStore.editOccurrence,
          occurrenceSeriesId: this.props.messagesStore.occurrenceSeriesId,
          occurrenceStartDate: this.props.messagesStore.messageToEdit?.startDate
        }}
      />
    );
  }
}